import { ReactNode, useState } from 'react';

import Box from '@mui/material/Box';

export function ErrorNotification({ error }: { error: ReactNode }) {
  const [resultErrorExpanded, setResultErrorExpanded] = useState(false);

  return (
    <Box
      component="span"
      sx={{
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        display: resultErrorExpanded ? 'block' : '-webkit-box',
        maxHeight: '200px',
        minHeight: 0,
        overflow: resultErrorExpanded ? 'auto' : 'hidden',
        position: 'relative',
        whiteSpace: 'pre-line',
        wordBreak: 'break-word',
      }}
    >
      {error}
      {!resultErrorExpanded && (
        <Box
          component="button"
          onClick={() => setResultErrorExpanded(true)}
          sx={{
            bgcolor: 'error.main',
            border: 'none',
            bottom: 3,
            color: 'inherit',
            cursor: 'pointer',
            fontSize: 'inherit',
            paddingX: 0.5,
            paddingY: 0,
            position: 'absolute',
            right: 0,
            textDecoration: 'underline',
            whiteSpace: 'nowrap',
          }}
        >
          ...Show more
        </Box>
      )}
    </Box>
  );
}
